// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';

export const updateCompanyContribution = value => ({
    type: actions.UPDATE_TCSM_PARTIAL_DEBIT_COMPANY_CONTRIBUTION,
    value
});



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/action-creators/company-contribution.js